import { Link, SpanContext, SpanStatus, TimeInput } from '@opentelemetry/api';
import { isString } from 'core/common/utils/string';
import {
  ATTRS_ERROR_MESSAGE,
  ATTRS_SPLIT_ID,
  ATTRS_TYPE,
  ATTRS_USER_ID,
} from './SemanticAttributes';
import { Span, SpanStatusCode } from './Span';
import { SpanAttribute, SpanAttributes } from './SpanAttributes';

export class CustomSpan {
  constructor(private readonly originalSpan: Span) {}

  spanContext(): SpanContext {
    return this.originalSpan.spanContext();
  }

  isRecording(): boolean {
    return this.originalSpan.isRecording();
  }

  setAttribute(key: string, value: SpanAttribute): CustomSpan {
    this.originalSpan.setAttribute(key, value);
    return this;
  }

  setAttributes(attributes: SpanAttributes): this {
    this.originalSpan.setAttributes(attributes);
    return this;
  }

  setType(type: string): this {
    this.originalSpan.setAttribute(ATTRS_TYPE, type);
    return this;
  }

  setSplitId(splitId: string): this {
    this.originalSpan.setAttribute(ATTRS_SPLIT_ID, splitId);
    return this;
  }

  setUserId(userId: string): this {
    this.originalSpan.setAttribute(ATTRS_USER_ID, userId);
    return this;
  }

  addEvent(
    name: string,
    attributesOrStartTime?: SpanAttributes | TimeInput,
    startTime?: TimeInput,
  ): this {
    this.originalSpan.addEvent(name, attributesOrStartTime, startTime);
    return this;
  }

  addLink(link: Link): this {
    this.originalSpan.addLink(link);
    return this;
  }

  addLinks(links: Link[]): this {
    this.originalSpan.addLinks(links);
    return this;
  }

  setStatus(status: SpanStatus): this {
    this.originalSpan.setStatus(status);
    return this;
  }

  updateName(name: string): this {
    this.originalSpan.updateName(name);
    return this;
  }

  succeed(endTime?: TimeInput) {
    this.end(endTime);
  }

  fail(error: Error | string, time?: TimeInput) {
    if (isString(error)) {
      this.setStatus({ code: SpanStatusCode.ERROR, message: error });
      this.setAttribute(ATTRS_ERROR_MESSAGE, error);

      this.end();
      return;
    }

    this.recordException(error, time);
    this.setStatus({ code: SpanStatusCode.ERROR, message: error.message });
    this.setAttribute(ATTRS_ERROR_MESSAGE, error.message);

    this.end();
  }

  private recordException(error: Error, time?: TimeInput) {
    this.originalSpan.recordException(error, time);
    return this;
  }

  private end(endTime?: TimeInput): void {
    this.originalSpan.end(endTime);
  }
}
